module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "stock-info"
  }, [_c('li', {
    staticClass: "stock renown-stock"
  }, [_c('span', {
    staticClass: "stock-name"
  }, [_vm._v(_vm._s(_vm.$t('common.ruyi-group2')))]), _vm._v(" "), _c('span', {
    staticClass: "stock-performance"
  }, [_vm._v(_vm._s(_vm.ruyi.price) + "¥ (" + _vm._s(_vm.ruyi.change) + "%)")])]), _vm._v(" "), _c('li', {
    staticClass: "stock renown-stock"
  }, [_c('span', {
    staticClass: "stock-name"
  }, [_vm._v("(株)レナウン")]), _vm._v(" "), _c('span', {
    staticClass: "stock-performance"
  }, [_vm._v(_vm._s(_vm.renown.price) + "¥ (" + _vm._s(_vm.renown.change) + "%)")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6931e958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/StockInfo.vue
// module id = 629
// module chunks = 1